import LoginLayout from "@/components/Layout/LoginLayout";
import { ResetPassword } from "@/features/auth/pages";
import Head from "next/head";
import type { ReactElement } from "react";

function ResetPasswordPage() {
	return (
		<>
			<Head>
				<title>パスワードの再設定 | ケアミー</title>
				<meta name="robots" content="noindex" />
			</Head>

			<ResetPassword />
		</>
	);
}

ResetPasswordPage.getLayout = function getLayout(page: ReactElement) {
	return <LoginLayout>{page}</LoginLayout>;
};

export default ResetPasswordPage;
